<template>
    <div class="trial-form-thank-you">
        <div class="trial-form-thank-you__inner">
            <span class="icon-checkmark trial-form-thank-you__icon"></span>
            <h1 class="trial-form-thank-you__header" v-html="thankYou.header"></h1>
            <span class="trial-form-thank-you__description" v-html="thankYou.description"></span>
            <span class="trial-form-thank-you__login" color="primary" @click="toggleLogin">{{ $t("Login.log_in") }}</span>
            <span class="trial-form-thank-you__note" v-html="thankYou.note"></span>
        </div>
    </div>
</template>

<script>
import LoginFormHelper from 'components/shared/mixins/loginFormHelper'

export default {
    name: 'trial-form-thank-you',
    mixins: [ LoginFormHelper ],
    data () {
        return {
            freeSubscriptionForm: {}
        }
    },
    computed: {
        isFormRegistration () {
            return this.freeSubscriptionForm && this.freeSubscriptionForm.type === 'registration'
        },
        isElisa () {
            return this.$route.params.slug === 'elisa'
        },
        thankYou () {
            if (this.isElisa) {
                return {
                    header: this.$t('FreeTrial.thank_you_header'),
                    description: this.$t('FreeTrial.thank_you_description_elisa'),
                    note: this.$t('FreeTrial.thank_you_note_elisa')
                }
            }
            if (this.isFormRegistration) {
                return {
                    header: this.$t('FreeTrial.registration_thank_you_header'),
                    description: this.$t('FreeTrial.registration_thank_you_description'),
                    note: this.$t('FreeTrial.registration_thank_you_note')
                }
            }

            return {
                header: this.$t('FreeTrial.thank_you_header'),
                description: this.$t('FreeTrial.thank_you_description'),
                note: this.$t('FreeTrial.thank_you_note')
            }
        }
    },
    methods: {
        goToLogin () {
            this.$store.dispatch('User/toggleLoginBox')
        }
    },
    async created () {
        this.freeSubscriptionForm = await this.$store.dispatch('User/loadFreeSubscription', this.$route.params.slug)
    }
}
</script>

<style lang="scss" scoped>
    .trial-form-thank-you {
        display: flex;
        justify-content: center;
        padding: 145px 0 65px;

        &.app-content {
            [class*="desktop"] & {
                padding: 145px 0 65px;
                background: $bright_gray;
            }
        }

        &__inner {
            padding: 40px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 40px;
            background: $white;
            border-radius: 24px;
            width: 600px;
        }

        &__icon {
            font-size: 8rem;
            color: $de_york;
        }

        &__header {
            font-family: QuickSand-ExtraBold, sans-serif;
            font-size: 2.8rem;
        }

        &__description {
            align-self: flex-start;
        }

        &__login {
            font-family:  Nunito-ExtraBold, sans-serif;
            align-self: stretch;
            font-size: 1.8rem;
            height: 38px;
            background: $orange;
            color: $white;
            border-radius: 30px;
            line-height: 38px;
            cursor: pointer;
            text-align: center;
        }

        &__note {
            font-family: Nunito-Italic, sans-serif;
            align-self: flex-start;
        }
    }
</style>
